import React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';

import Referral from '@pages/referral/ui/PageReferral';
import { optionsSettings } from '@entities/settings/api';

export const Route = createFileRoute('/_auth/_layout/referral')({
  beforeLoad: async ({ context }) => {
    const settings = await context.queryClient.ensureQueryData(
      optionsSettings(),
    );

    if (!settings?.referral_program?.enabled) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: Referral,
});
